exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-menu[data-v-3e1e48ce] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
